import { initializeApp } from "firebase/app";
import { ReCaptchaEnterpriseProvider, initializeAppCheck } from "firebase/app-check";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

const firebaseConfig = {
  projectId: "scg-beratung",
  appId: "1:764880870505:web:e05b532cdeacee096016f8",
  storageBucket: "scg-beratung.firebasestorage.app",
  apiKey: "AIzaSyDGRFg0wB8Ee3--wEto8-9RK0EgBa3Ku3I",
  authDomain: "scg-beratung.firebaseapp.com",
  messagingSenderId: "764880870505"
};

export const app = initializeApp(firebaseConfig);
export const functions = getFunctions(app, "europe-west1");
export const useEmulators = import.meta.env.VITE_USE_EMULATORS === "true";

if (useEmulators) {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

const appCheckKey = import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY;
if (appCheckKey && !useEmulators) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(appCheckKey),
    isTokenAutoRefreshEnabled: true
  });
}
